import {
    SET_VISIBLE,
  } from '../constants/caja.constants';
  
  export const setVisible = payload => ({
    type: SET_VISIBLE,
    payload,
  });
